<template>
  <el-dialog
    class="syncProgress"
    :visible.sync="visible"
    :before-close="handleClose"
    title="店铺类目同步"
  >
    <div class="title">{{text}}</div>
    <el-progress v-show="!hideProgress" :text-inside="true" :stroke-width="20" :percentage="percentageValue"></el-progress>
  </el-dialog>
</template>

<script>
import {getSyncShopCategoryStatus} from '@servers/base/shop/index.js';
export default {
  props: {
    percentage: {
      type: [String, Number],
      default: 0
    }
  },
  data() {
    return {
      visible: false,
      hideProgress: false,
      text: '同步中...',
      percentageValue: this.percentage || 0,
      timmer: null,
      timmer2: null,
      timmer3: null
    }
  },
  methods: {
    showDialog({shopId} = {}) {
      this.clearTimer();
      this.text = '同步中...'
      this.percentageValue = 0
      this.visible = true
      this.hideProgress = false
      this.getSyncShopCategoryStatus(this.syncFinishCb, shopId)
    },
    handleClose() {
      this.visible = false
    },
    getSyncShopCategoryStatus(callbackFn, shopId) {
      getSyncShopCategoryStatus({shopId}).then((res) => {
        // 使用后端返回的 loading 字段
        if (res?.loading !== undefined) {
          this.percentageValue = Math.ceil(res.loading)
        }
        if (res.finished) {
          this.percentageValue = 100
          callbackFn(res)
        } else {
          setTimeout(() => {
            this.getSyncShopCategoryStatus(callbackFn, shopId)
          }, 1000)
        }
      })
    },
    syncFinishCb(data) {
      if (data.errorMsg) {
        this.text = `同步错误：\n${data.errorMsg}`
        // 错误信息展示的时候需要隐藏掉进度条
        this.hideProgress = true
      } else {
        this.text = `同步成功`
        this.timmer3 = setTimeout(() => {
          this.visible = false
        }, 1200)
      }
    },
    clearTimer() {
      this.timmer && clearTimeout(this.timmer)
      this.timmer2 && clearInterval(this.timmer2)
      this.timmer3 && clearTimeout(this.timmer3)
    }
  },
  beforeDestroy() {
    this.clearTimer()
  }
}
</script>

<style lang="scss" scoped>
.syncProgress {
  & ::v-deep .el-dialog__body {
    min-height: 88px;
  }
  .title {
    margin-bottom: 10px;
    white-space: pre-line;
  }
}
</style>